import Choices from 'choices.js'
import { HighlightFormInvalid } from '@/plugins/api/highlight_form_invalid'
import lang from '@/plugins/lang'

export default class CustomChoiceValue {
    /**
     * @param {Choices} choice
     * @param {string} customInputName
     * @param {{value: string, label: string}?} choiceTrigger
     */
    constructor(choice, customInputName, choiceTrigger) {
        this.choice = choice
        this.form = this.choice.passedElement.element.form
        this.customInput = this.form.querySelector(`[name="${customInputName}"]`)

        this.choiceTrigger = choiceTrigger || { value: 'other', label: lang.t('choicesjs:customChoiceValue') }

        this.highlight = new HighlightFormInvalid()

        this.highlight.form = this.form
    }

    setup() {
        this.choice.passedElement.element.addEventListener('change', () => {
            this.choiceValueChanged(this.choice.getValue(true))
        })

        this.choice.setChoices([this.choiceTrigger])

        if (!this.customInput.value) {
            this.choiceValueChanged(this.choice.getValue(true))
            return
        }

        this.choice.setChoiceByValue(this.customInput.value)

        const value = this.choice.getValue(true)

        if (value !== this.customInput.value) {
            this.choice.setChoiceByValue(this.choiceTrigger.value)
        } else {
            this.getInputParentGroup().classList.add('d-hidden')
        }
    }

    choiceValueChanged(value) {
        const groupEl = this.getInputParentGroup()

        if (value !== this.choiceTrigger.value) {
            groupEl.classList.add('d-hidden')

            this.customInput.value = value || ''
        } else {
            this.customInput.value = ''

            groupEl.classList.remove('d-hidden')
        }

        this.customInput.dispatchEvent(new Event('change'))
    }

    getInputParentGroup() {
        let groupEl = this.customInput.parentElement

        return groupEl.classList.contains('form-label-input') ? groupEl.parentElement : groupEl
    }

    displayMessageError() {
        const customFeedback = this.form.querySelector(`.invalid-feedback[for="${this.customInput.name}"]`)

        if (!customFeedback || !customFeedback.classList.contains('active')) {
            return
        }

        const groupEl = customFeedback.parentElement

        if (!groupEl.classList.contains('d-hidden')) {
            return
        }

        groupEl.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'))

        customFeedback.classList.remove('active')

        this.highlight.highlightInputSimple(this.choice.passedElement.element, [...customFeedback.children].map(el => el.textContent))
    }
}
